import React from "react";
import { Button } from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import styles from "./StatusView.module.css";

interface StatusViewProps {
  code: string;
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
  icon: React.ReactNode;
}

const StatusView: React.FC<StatusViewProps> = ({
  code,
  title,
  description,
  actionLabel,
  onAction,
  icon,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.code}>{code}</div>
        <div className={styles.iconBox}>{icon}</div>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.description}>{description}</p>
        <Button
          variant="contained"
          color="primary"
          onClick={onAction}
          startIcon={<ArrowBackRoundedIcon />}
          className={styles.actionButton}
        >
          {actionLabel}
        </Button>
      </div>
    </div>
  );
};

export default StatusView;
